import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import {
    INTERACTA_USER_AGENT_CLIENT,
    InteractaUserAgentInterceptor,
} from '../interceptors/interacta-user-agent.interceptor';

/**
 *
 * @param client value of the `client` field of the `Interacta-User-Agent` header (e.g. `interacta_web`)
 * @param standaloneInterceptors use false in legacy applications importing `HttpClientModule`, true in standalone applications using `provideHttpClient(withInterceptors(interactaUserAgentInterceptor))`
 * @returns
 */
export const provideInteractaUserAgent = (
    client: string,
    standaloneInterceptors = true,
): EnvironmentProviders =>
    makeEnvironmentProviders([
        { provide: INTERACTA_USER_AGENT_CLIENT, useValue: client },
        standaloneInterceptors
            ? InteractaUserAgentInterceptor
            : {
                  provide: HTTP_INTERCEPTORS,
                  useClass: InteractaUserAgentInterceptor,
                  multi: true,
              },
    ]);
